import React, { useEffect, useState } from "react"
import { Container } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getCookie } from 'utils/cookie';
import sections from "../constants/menu.json";
//const sections = [];

function DropDownMenu(props) {
  const { linkTitle, childList } = props;
  return (
    <NavDropdown title={linkTitle} id="collapsible-nav-dropdown">
      {childList.map((oneChild, index) => (
        <NavDropdown.Item key={index} href={oneChild.url}>{oneChild.title}</NavDropdown.Item>
      ))}
    </NavDropdown>)
}


export default function Header() {

  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");

  useEffect(() => {
    setUserId(getCookie("UserId"));
    setUserName(getCookie("UserName"));
  }, [])

  const getSignInStatus = () => {
    if (userId && userName) {
      return "Signed in as:" + { userName } + "(" + { userId } + ")";
    } else {
      return "";
    }
  }
  return (<header>

    <Navbar collapseOnSelect expand="lg">
      <Container>
        <Navbar.Brand href="/">
          <Image
            alt=""
            src="/tca-logo.png"
            width="70"
            height="70"
            className="d-inline-block align-top"
          />{' '}

        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />

        <Navbar.Offcanvas
          id='responsive-navbar-nav'
          aria-labelledby='offcanvasNavbarLabel-expand-sm'
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id='offcanvasNavbarLabel-expand-sm'>
              Menu
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>





            <Nav
              className="me-auto my-2 my-lg-0"
              style={{ maxHeight: '100px' }}
            >


              {sections.map((section, index) => (
                section.hasChild ? <DropDownMenu key={index} linkTitle={section.title} childList={section.childList} /> : <Nav.Link key={index} href={section.url}>{section.title}</Nav.Link>
              ))}
              {/*<Nav.Link href={"/login"}>Login</Nav.Link>*/}


            </Nav>
            <Navbar.Text className="justify-content-end">
              {getSignInStatus()}
            </Navbar.Text>
            <div className="ad-container d-none d-lg-block border">

              {/* Place your advertisement content here */}
            </div>

          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
    {/*
    <div className="ad-container d-md-none border">

       Place your advertisement content here
    </div>
 */}

  </header>
  )
}